import {
  Container,
  Grid,
  Box,
  ButtonBase,
  Button,
  useTheme,
  Slide,
  Typography,
  Paper,
  Avatar,
  Card,
  CardMedia,
  CardActions,
  CardContent,
  Grow,
  makeStyles,
  useMediaQuery,
  Fade
} from "@material-ui/core";
import { useState, useEffect, useLayoutEffect } from "react";

import MuiAlert from "@material-ui/lab/Alert";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Loading } from "../../components/shared/loading";
import { Link } from "react-router-dom";
import PhoneIcon from "@material-ui/icons/Phone";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import InstagramEmbed from './instaEmbedded'

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  nounderline: {
    "&:hover": { textDecoration: "none" },
  },
  heroSection: {
    position: "relative",
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    minHeight: "45vh",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  heroContent: {
    position: "relative",
    zIndex: 2,
    color: "#ffffff",
    textAlign: "center",
    padding: "32px 20px",
  },
  heroTitle: {
    fontSize: "clamp(1.6rem, 3.5vw, 2.2rem)",
    fontWeight: 600,
    letterSpacing: "-0.01em",
    lineHeight: 1.2,
    marginBottom: "12px",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 0.95rem)",
    fontWeight: 300,
    opacity: 0.9,
    maxWidth: "480px",
    margin: "0 auto 24px",
    lineHeight: 1.5,
  },
  heroButton: {
    backgroundColor: "#ffffff",
    color: "#6b1b6b",
    padding: "10px 28px",
    fontSize: "0.85rem",
    fontWeight: 600,
    borderRadius: "25px",
    textTransform: "none",
    boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
    }
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: "8px",
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#777777",
    textAlign: "center",
    maxWidth: "450px",
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  serviceCard: {
    background: "#ffffff",
    borderRadius: "12px",
    overflow: "hidden",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    height: "200px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down('sm')]: {
      height: "180px",
    },
    [theme.breakpoints.down('xs')]: {
      height: "160px",
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(107, 27, 107, 0.1)",
    }
  },
  serviceImage: {
    height: 120,
    backgroundSize: "cover",
    backgroundPosition: "center",
    [theme.breakpoints.down('sm')]: {
      height: 100,
    },
    [theme.breakpoints.down('xs')]: {
      height: 90,
    },
  },
  serviceTitle: {
    fontSize: "0.8rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    padding: "12px 10px",
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.8rem",
      padding: "10px 8px",
    },
  },
  testimonialCard: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "2px",
      background: "linear-gradient(90deg, #6b1b6b 0%, #9b3b9b 100%)",
    }
  },
  testimonialQuote: {
    fontSize: "0.8rem",
    lineHeight: 1.6,
    color: "#444444",
    fontStyle: "italic",
    marginBottom: "14px",
  },
  testimonialAuthor: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  testimonialAvatar: {
    width: 36,
    height: 36,
    border: "2px solid #6b1b6b",
  },
  clientLogo: {
    background: "#ffffff",
    borderRadius: "10px",
    padding: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    height: "90px",
    minHeight: "80px",
    [theme.breakpoints.down('md')]: {
      height: "85px",
      minHeight: "75px",
      padding: "12px",
    },
    [theme.breakpoints.down('sm')]: {
      height: "80px",
      minHeight: "70px",
      padding: "10px",
    },
    [theme.breakpoints.down('xs')]: {
      height: "70px",
      minHeight: "60px",
      padding: "8px",
    },
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "0 4px 16px rgba(107, 27, 107, 0.08)",
    }
  },
  ceoSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    position: "relative",
    overflow: "hidden",
  },
  ceoQuote: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    textAlign: "center",
    maxWidth: "700px",
    margin: "0 auto 12px",
    position: "relative",
    zIndex: 1,
  },
  ceoName: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
  ctaSection: {
    background: "linear-gradient(135deg, rgba(107, 27, 107, 0.04) 0%, rgba(107, 27, 107, 0.08) 100%)",
    borderRadius: "12px",
    padding: "32px 24px",
    textAlign: "center",
  },
  ctaTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    color: "#4c004c",
    marginBottom: "8px",
  },
  ctaSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    maxWidth: "400px",
    margin: "0 auto 20px",
    lineHeight: 1.5,
  },
  ctaButton: {
    backgroundColor: "#6b1b6b",
    color: "#ffffff",
    padding: "10px 28px",
    fontSize: "0.85rem",
    fontWeight: 600,
    borderRadius: "25px",
    textTransform: "none",
    boxShadow: "0 2px 12px rgba(107, 27, 107, 0.25)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#5a155a",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 16px rgba(107, 27, 107, 0.35)",
    }
  },
  section: {
    padding: "40px 0",
  },
  sectionAlt: {
    padding: "40px 0",
    background: "#fafafa",
  },
}));

export const Home = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);

  const [tests, setTests] = useState();
  const [videoTests, setVideoTests] = useState();
  const [cars, setCars] = useState();
  const [services, setServices] = useState();
  const [clients, setClients] = useState();
  const [size, setSize] = useState(0);
  const [active, setActive] = useState(0);

  // Define breakpoints
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  const getBackgroundColor = (key) => {
    const itemsPerRow = isXl ? 4 : isLg ? 4 : isMd ? 3 : isSm ? 3 : 2;
    const rowNumber = Math.floor(key / itemsPerRow);
    const positionInRow = key % itemsPerRow;
    const isEvenRow = rowNumber % 2 === 0;
    const isEvenPosition = positionInRow % 2 === 0;
    if (isEvenRow) {
      return isEvenPosition ? 'rgba(76, 0, 76, 0.05)' : '#fff';
    } else {
      return isEvenPosition ? '#fff' : 'rgba(76, 0, 76, 0.05)';
    }
  };

  useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 1);
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        handleClick();
      }
    });

    Axios.get("/api/gethomedata", {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setTests(res.data.tests);
        setCars(res.data.slides);
        setServices(res.data.services);
        setClients(res.data.clients);
        setVideoTests(res.data.videotests)
        setIsloading(false);
      }
    });
  };

  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords}></meta>
      </Helmet>

      {isloading ? (
        <Loading />
      ) : (
        <>
          {/* Hero Section */}
          <Box className={classes.heroSection}>
            <Container maxWidth="lg">
              <Fade in={true} timeout={1000}>
                <Box className={classes.heroContent}>
                  <Typography className={classes.heroTitle}>
                    Transform Your Business<br />
                    <span style={{ fontWeight: 400 }}>With Innovative IT Solutions</span>
                  </Typography>
                  <Typography className={classes.heroSubtitle}>
                    We craft cutting-edge digital experiences that drive growth, 
                    enhance efficiency, and deliver measurable results for your business.
                  </Typography>
                  <Button 
                    className={classes.heroButton}
                    component={Link}
                    to="/our-services"
                    endIcon={<ArrowForwardIcon />}
                  >
                    Explore Our Services
                  </Button>
                </Box>
              </Fade>
            </Container>

            {/* Carousel overlay */}
            {cars && (
              <Box sx={{ 
                position: "absolute", 
                bottom: 0, 
                left: 0, 
                right: 0, 
                opacity: 0.15,
                pointerEvents: "none"
              }}>
                <Carousel
                  animation="slide"
                  autoPlay={true}
                  showIndicators={false}
                  showArrows={false}
                  centerMode={true}
                  centerSlidePercentage={size < 960 ? 100 : 50}
                  infiniteLoop
                  showThumbs={false}
                  transitionTime={1200}
                  statusFormatter={() => ``}
                >
                  {cars.map((item, i) => (
                    <div key={i}>
                      <img src={item.slide} alt={item.text} style={{ width: "100%" }} />
                    </div>
                  ))}
                </Carousel>
              </Box>
            )}
          </Box>

          {/* Services Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Expertise
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Delivering excellence through tailored IT solutions that transform businesses
                  </Typography>
                </Box>
              </Slide>

              {services && (
                <Grid container spacing={3}>
                  {services.map((service, key) => (
                    <Grid item xs={6} sm={6} md={4} lg={3} key={key}>
                      <Grow in={true} timeout={600 + key * 100}>
                        <ButtonBase
                          className={classes.nounderline}
                          component={Link}
                          to={"/service-details/" + service.serv_name.split(" ").join("-") + "/" + service.serv_id}
                          style={{ width: "100%", height: "100%" }}
                        >
                          <Card className={classes.serviceCard}>
                            <CardMedia
                              className={classes.serviceImage}
                              image={"/static/services/" + service.serv_image}
                              title={service.serv_name}
                            />
                            <Typography className={classes.serviceTitle}>
                              {service.serv_name}
                            </Typography>
                          </Card>
                        </ButtonBase>
                      </Grow>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Container>
          </Box>

          {/* Testimonials Section */}
          <Box className={classes.sectionAlt}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Client Stories
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Discover how our solutions have made a difference
                  </Typography>
                </Box>
              </Slide>

              {tests && tests.length !== 0 && (
                <Carousel
                  autoPlay={true}
                  showIndicators={true}
                  showArrows={false}
                  centerMode={false}
                  infiniteLoop
                  stopOnHover
                  swipeable
                  showThumbs={false}
                  transitionTime={800}
                  interval={5000}
                  statusFormatter={() => ``}
                >
                  {tests.map((item, i) => (
                    <Box key={i} style={{ padding: "0 16px 32px" }}>
                      <Card className={classes.testimonialCard}>
                        <FormatQuoteIcon style={{ 
                          fontSize: 32, 
                          color: "rgba(107, 27, 107, 0.12)",
                          marginBottom: 12 
                        }} />
                        <Typography className={classes.testimonialQuote}>
                          "{item.test_msg}"
                        </Typography>
                        <Box className={classes.testimonialAuthor}>
                          <Avatar
                            alt={item.test_name}
                            src={"/static/testms/" + item.test_image}
                            className={classes.testimonialAvatar}
                          />
                          <Box>
                            <Typography style={{ 
                              fontWeight: 600, 
                              color: "#4c004c",
                              fontSize: "0.95rem"
                            }}>
                              {item.test_name}
                            </Typography>
                            <Typography style={{ 
                              color: "#666666",
                              fontSize: "0.85rem"
                            }}>
                              {item.test_prof}
                            </Typography>
                          </Box>
                        </Box>
                      </Card>
                    </Box>
                  ))}
                </Carousel>
              )}
            </Container>
          </Box>

          {/* Video Testimonials Section */}
          {videoTests && videoTests.length > 0 && (
            <Box className={classes.section}>
              <Container maxWidth="lg">
                <Slide direction="up" in={true} timeout={800}>
                  <Box>
                    <Typography className={classes.sectionTitle}>
                      Video Testimonials
                    </Typography>
                    <Typography className={classes.sectionSubtitle}>
                      Witness the journey and success of our clients in their own words
                    </Typography>
                  </Box>
                </Slide>

                <Grid container spacing={3} justifyContent="center">
                  {videoTests.map((videotest, i) => (
                    <Grid item xs={12} sm={6} md={4} key={i}>
                      <Grow in={true} timeout={800 + i * 200}>
                        <Box style={{ 
                          borderRadius: "16px", 
                          overflow: "hidden",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.06)"
                        }}>
                          <InstagramEmbed url={videotest.video_url} />
                        </Box>
                      </Grow>
                    </Grid>
                  ))}
                </Grid>
              </Container>
            </Box>
          )}

          {/* Clients Section */}
          <Box className={classes.sectionAlt}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Trusted Partners
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Celebrating successful partnerships with industry leaders
                  </Typography>
                </Box>
              </Slide>

              {clients && (
                <Grid container spacing={3}>
                  {clients.map((client, key) => (
                    <Grid item xs={6} sm={4} md={3} lg={3} key={key}>
                      <Grow in={true} timeout={600 + key * 100}>
                        <ButtonBase
                          component="a"
                          href={client.site_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ width: "100%" }}
                        >
                          <Box className={classes.clientLogo}>
                            <img
                              src={"/static/clients/" + client.image_url}
                              alt={client.name}
                              style={{ 
                                maxWidth: "100%", 
                                maxHeight: "80px",
                                minHeight: "50px",
                                objectFit: "contain"
                              }}
                            />
                          </Box>
                        </ButtonBase>
                      </Grow>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Container>
          </Box>

          {/* CEO Quote Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={1000}>
                <Box className={classes.ceoSection}>
                  <FormatQuoteIcon style={{ 
                    fontSize: 40, 
                    color: "rgba(255, 255, 255, 0.15)",
                    display: "block",
                    margin: "0 auto 16px"
                  }} />
                  <Typography className={classes.ceoQuote}>
                    "At Arawinz, we blend innovation with dedication to deliver exceptional solutions. 
                    Our team's journey is marked by a relentless pursuit of excellence and a deep 
                    commitment to understanding and fulfilling our clients' needs. Together, we are 
                    more than just a team - we are architects of the future, crafting a smarter, 
                    more connected world."
                  </Typography>
                  <Typography className={classes.ceoName}>
                    — Dr. P. Srinivas Rao, CEO
                  </Typography>
                </Box>
              </Slide>
            </Container>
          </Box>

          {/* CTA Section */}
          <Box style={{ padding: "40px 0 80px" }}>
            <Container maxWidth="md">
              <Slide direction="up" in={true} timeout={1000}>
                <Box className={classes.ctaSection}>
                  <Typography className={classes.ctaTitle}>
                    Ready to Transform Your Business?
                  </Typography>
                  <Typography className={classes.ctaSubtitle}>
                    Let's discuss how we can help you achieve your goals with our innovative solutions.
                  </Typography>
                  <Button 
                    className={classes.ctaButton}
                    component={Link}
                    to="/get-in-touch"
                    startIcon={<PhoneIcon />}
                  >
                    Get In Touch
                  </Button>
                </Box>
              </Slide>
            </Container>
          </Box>
        </>
      )}
    </div>
  );
};

